import { Fragment, useState } from "react"
import { Modal, Form, DatePicker, Button } from "antd"
import { useForm } from "antd/lib/form/Form"
import { baseAxiosComplete } from "../../../tool/axios"
import _ from 'lodash'

interface Prop {
    serviceRecord?: ServiceRecord
    onChange?: () => void
}

interface ServiceRecord {
    work_id: string, // 上单标识
    nursing_care_type: number // 护理模式
    nursing_care_type_desc: string // 护理模式描述
    belong_nursing_name: string  // 护理师
    service_status: number // 服务状态
    service_start_date: string // 服务开始日期
    service_end_date: string // 服务结束日期
    service_days: number // 服务天数
}

export default function (prop: Prop) {

    const [visible, setVisible] = useState<boolean>(false)
    const [form] = useForm()

    const onFinish = () => {
        baseAxiosComplete.post('/yuesao_center/customer/detail/down_hospital_escort', {
            work_id: prop.serviceRecord?.work_id,
            service_end_date: form.getFieldValue('service_end_date') ? form.getFieldValue('service_end_date').format('YYYY-MM-DD HH:mm:ss') : ''
        }).then(res => {
            if (res.status === 0) {
                setVisible(false)
                if (prop.onChange) prop.onChange()
            }
        })
    }

    return <Fragment>
        {/* 月嫂中心 -> 客户管理 -> 客户详情 -> 下单医院陪护 */}
        <Button type="primary" style={{ marginLeft: 16, marginBottom: 16 }} size="small" onClick={() => { setVisible(true) }}>下单医院陪护</Button>

        <Modal title="下单医院陪护" width={350} visible={visible} onCancel={() => { setVisible(false) }} onOk={onFinish}>
            <p>当前护理师：{prop.serviceRecord && prop.serviceRecord?.belong_nursing_name}</p>
            <p>开始日期：{prop.serviceRecord && prop.serviceRecord?.service_start_date}</p>
            <p>结束日期：{prop.serviceRecord && prop.serviceRecord?.service_end_date}</p>
            <p>天数：{prop.serviceRecord && prop.serviceRecord?.service_days}</p>
            <p style={{ fontWeight: 'bold', fontSize: 14, color: 'red' }}>注意：请确认护理师下单信息再提交表单！</p>

            <Form form={form} style={{ marginTop: 20 }} >
                <Form.Item required name="service_end_date" label="下单时间" >
                    <DatePicker showTime />
                </Form.Item>
            </Form>
        </Modal>
    </Fragment>
}